type BooleanEnv = string | undefined;

const parseBooleanEnv = (value: BooleanEnv, defaultValue: boolean): boolean => {
  if (value === undefined) {
    return defaultValue;
  }

  const normalized = value.trim().toLowerCase();
  if (normalized.length === 0) {
    return defaultValue;
  }

  return normalized === "true" || normalized === "1" || normalized === "yes" || normalized === "on";
};

export const featureFlags = {
  shop: parseBooleanEnv(import.meta.env.VITE_ENABLE_SHOP, true),
  games: {
    ampedUp: parseBooleanEnv(import.meta.env.VITE_ENABLE_AMPED_UP, true),
    kinematicsLab: parseBooleanEnv(import.meta.env.VITE_ENABLE_KINEMATICS_LAB, true),
    magnetismMiniGolf: parseBooleanEnv(import.meta.env.VITE_ENABLE_MAGNETISM_MINI_GOLF, true),
    plotThePath: parseBooleanEnv(import.meta.env.VITE_ENABLE_PLOT_THE_PATH, false),
  },
};
